module.exports = __webpack_public_path__ + "assets/img/other.76444893.svg";